var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 63,
    viewBox: "0 0 63 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8588_2735)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.4943 6.10352e-05L31.0735 1.42937V42.9008L31.4943 43.3206L50.7445 31.9416L31.4943 6.10352e-05Z",
    fill: "#343434"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4943 3.05176e-05L12.2437 31.9416L31.4943 43.3206V23.1915V3.05176e-05Z",
    fill: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4944 46.9653L31.2572 47.2545V62.0272L31.4944 62.7195L50.7563 35.5922L31.4944 46.9653Z",
    fill: "#3C3C3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4943 62.7195V46.9653L12.2437 35.5922L31.4943 62.7195Z",
    fill: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4943 43.3207L50.7445 31.9418L31.4943 23.1917V43.3207Z",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2437 31.9418L31.4943 43.3207V23.1917L12.2437 31.9418Z",
    fill: "#393939"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8588_2735"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 62.72,
    height: 62.72,
    fill: "white",
    transform: "translate(0.140015)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEth);
export default __webpack_public_path__ + "static/media/eth.a9b3a3b527437000ed1560584caad893.svg";
export { ForwardRef as ReactComponent };